import { RcFile } from 'antd/lib/upload';
import Papa from 'papaparse';

import { highlightedHeaders } from './highlightedHeaders';

import { CreateDonationSchemaType } from '../../schema';

const headersMap = highlightedHeaders.reduce((headers, { label, key }) => {
  return { ...headers, [label]: key };
}, {} as Record<string, string>);

const parseNumber = (value: string) => Number(value);
const parseBoolean = (value: string) => value.toLowerCase() === 'true';
const parseArray = (value: string) => value.split('|');

const parserByField: Partial<
  Record<keyof CreateDonationSchemaType, (value: string) => any>
> = {
  weatherTypes: parseArray,
  holdersPosition: parseArray,
  emotionalSupport: parseArray,
  dislikes: parseArray,
  likes: parseArray,
  treatPreferences: parseArray,

  temperature: parseNumber,
  pulse: parseNumber,
  respiration: parseNumber,
  packedCellVolume: parseNumber,
  totalSolids: parseNumber,
  weight: parseNumber,
  weatherTemperature: parseNumber,
  maxLimit: parseNumber,
  approvedDonationsMl: parseNumber,
  actual: parseNumber,

  working: parseBoolean,
  shouldDonate: parseBoolean,
};

export const getDonationsFromCsv = (
  file: RcFile
): Promise<CreateDonationSchemaType[]> => {
  return new Promise<CreateDonationSchemaType[]>((resolve, _reject) => {
    Papa.parse<CreateDonationSchemaType>(file, {
      skipEmptyLines: true,
      header: true,
      quoteChar: `\"`,
      transformHeader: (header) => {
        const cleanHeader = header.trim();

        if (headersMap[cleanHeader]) {
          return headersMap[cleanHeader];
        }

        return cleanHeader;
      },
      transform: (value, field: keyof CreateDonationSchemaType) => {
        const parser = parserByField[field];

        if (value === undefined || value === null || value === '') {
          return undefined;
        }

        return parser ? parser(value) : value;
      },
      complete: (results) => {
        resolve(results.data);
      },
    });
  });
};
